import { Drawer } from '@mui/material';
import { FC, useContext, useMemo } from 'react';
import { TranslationContext } from '../../handlers/TranslationsHandler';
import { TilesInterface } from '../Grid/tiles';
import { TileOverview } from '../TileOverview';

import * as S from './styles';
import { TileCategoriesEnum, TILES } from './tileSummaries';
import { TilesContext } from '../../handlers/TilesHandler';
import { useMatomo } from '@datapunt/matomo-tracker-react';
import {
  filterTilesByCategory,
  handleAddTile,
  sortedTileCategories
} from '../../helpers/tilesHelper';

interface IDrawerWrapper {
  visibleDrawer: boolean;
  setVisibleDrawer: React.Dispatch<React.SetStateAction<boolean>>;
  tiles: TilesInterface[];
  setTiles: React.Dispatch<React.SetStateAction<TilesInterface[]>>;
  currentTileKey: string | undefined;
  mountDrawer: boolean;
}

export const DrawerWrapper: FC<IDrawerWrapper> = ({
  visibleDrawer,
  setVisibleDrawer,
  tiles,
  setTiles,
  currentTileKey,
  mountDrawer
}) => {
  const { translate, language } = useContext(TranslationContext);
  const { isInSpecialMode, isInFinancesMode } = useContext(TilesContext);
  const { trackEvent } = useMatomo();

  const filterAndSortCatalogueTiles = (category: string | TileCategoriesEnum) =>
    filterTilesByCategory(category as string, translate).map(tile => {
      const tileName = tile.name;
      const isPremiumOnly = isInSpecialMode && (tile.premiumTile as boolean);

      return (
        <div
          data-tour={`side-tile-${tile.title}`}
          key={`tile-overview-${tile.title}`}
          data-testid="tile-overview"
        >
          <TileOverview
            name={tile.name}
            title={translate(tile.title)}
            description={translate(tile.description)}
            onAdd={() => {
              handleAddTile(
                tileName,
                tiles,
                setTiles,
                currentTileKey,
                setVisibleDrawer,
                trackEvent
              );
            }}
            selected={tiles.some(tileItem => tileItem.name === tileName)}
            isPremiumOnly={isPremiumOnly}
          />
        </div>
      );
    });

  const processedTiles = useMemo(() => {
    return sortedTileCategories(isInFinancesMode).map(category => (
      <div key={`category-${category}`} data-testid="tile-category">
        <S.CategoryTitle>
          <h3>{translate(category)}</h3>
        </S.CategoryTitle>
        {filterAndSortCatalogueTiles(category)}
      </div>
    ));
  }, [currentTileKey, tiles, language, isInFinancesMode]);

  return (
    <Drawer
      style={{
        visibility: mountDrawer ? 'visible' : 'hidden',
        position: 'absolute'
      }}
      anchor="left"
      open={visibleDrawer}
      onClose={() => setVisibleDrawer(false)}
      ModalProps={{
        container: document.getElementsByClassName('configurator-layout')[0]
      }}
    >
      <S.TileSummaries>{processedTiles}</S.TileSummaries>
    </Drawer>
  );
};
